import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["className", "id", "size", "currency", "locale", "currencySymbol", "mode", "aria-label", "aria-describedby", "isDisabled", "isInvalid", "isReadOnly", "isFullWidth", "minimumValue", "maximumValue", "preset", "canModifyValueOnWheel"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { forwardRef } from 'react';
import { ThemeProvider } from 'styled-components';
import cx from 'classnames';
import { predefinedOptions } from './ReactNumeric';
import { prefix } from '../../tools/settings';
import getSymbolFromCurrency from 'currency-symbol-map';
import { StyledCurrencyInput, StyledCurrencyInputContainer } from './CurrencyInput.styles';
import { jsx as _jsx } from "react/jsx-runtime";
var CurrencyInput = forwardRef(function (_ref, ref) {
  var _cx;

  var customClassName = _ref.className,
      id = _ref.id,
      size = _ref.size,
      currency = _ref.currency,
      _ref$locale = _ref.locale,
      locale = _ref$locale === void 0 ? 'en-GB' : _ref$locale,
      _ref$currencySymbol = _ref.currencySymbol,
      currencySymbol = _ref$currencySymbol === void 0 ? '$' : _ref$currencySymbol,
      _ref$mode = _ref.mode,
      mode = _ref$mode === void 0 ? 'light' : _ref$mode,
      ariaLabel = _ref['aria-label'],
      ariaDescribedby = _ref['aria-describedby'],
      _ref$isDisabled = _ref.isDisabled,
      isDisabled = _ref$isDisabled === void 0 ? false : _ref$isDisabled,
      _ref$isInvalid = _ref.isInvalid,
      isInvalid = _ref$isInvalid === void 0 ? false : _ref$isInvalid,
      _ref$isReadOnly = _ref.isReadOnly,
      isReadOnly = _ref$isReadOnly === void 0 ? false : _ref$isReadOnly,
      _ref$isFullWidth = _ref.isFullWidth,
      isFullWidth = _ref$isFullWidth === void 0 ? false : _ref$isFullWidth,
      _ref$minimumValue = _ref.minimumValue,
      minimumValue = _ref$minimumValue === void 0 ? 0 : _ref$minimumValue,
      _ref$maximumValue = _ref.maximumValue,
      maximumValue = _ref$maximumValue === void 0 ? 10000000000000 : _ref$maximumValue,
      preset = _ref.preset,
      _ref$canModifyValueOn = _ref.canModifyValueOnWheel,
      canModifyValueOnWheel = _ref$canModifyValueOn === void 0 ? false : _ref$canModifyValueOn,
      rest = _objectWithoutProperties(_ref, _excluded);

  var getCurrencySymbol = currency ? getSymbolFromCurrency(currency) : currencySymbol;
  var getCurrencyCode = getCurrencySymbol === currency ? null : currency;
  var formatter = new Intl.NumberFormat(locale, {
    style: 'currency',
    currency: currency
  });
  var formatterParts = formatter.formatToParts(1000);

  var getDecimalPart = function getDecimalPart() {
    var _formatterParts$find;

    var part = (_formatterParts$find = formatterParts.find(function (data) {
      return data.type === 'decimal';
    })) === null || _formatterParts$find === void 0 ? void 0 : _formatterParts$find.value;
    return part ? part : '.';
  };

  var getGroupPart = function getGroupPart() {
    return formatterParts.find(function (data) {
      return data.type === 'group';
    }).value;
  };

  function getPreset(preset) {
    var presets = {
      euro: 'euro',
      dollar: 'dollar',
      jpy: 'Japanese',
      chf: 'Swiss',
      cny: 'Chinese',
      brl: 'Brazilian',
      "try": 'Turkish',
      gbp: 'British'
    };
    return presets[preset];
  }

  var className = cx((_cx = {}, _defineProperty(_cx, "".concat(prefix, "-currency-input"), true), _defineProperty(_cx, "".concat(prefix, "-currency-input--hasNoCurrency"), !currency), _defineProperty(_cx, "".concat(prefix, "-currency-input--invalid"), isInvalid), _defineProperty(_cx, "".concat(prefix, "-currency-input--shift"), getCurrencySymbol.length > 2), _defineProperty(_cx, customClassName, !!customClassName), _cx));
  return _jsx(ThemeProvider, {
    theme: {
      mode: mode,
      size: size
    },
    children: _jsx(StyledCurrencyInputContainer, {
      isFullWidth: isFullWidth,
      isDisabled: isDisabled,
      className: cx(_defineProperty({}, "".concat(prefix, "-currency-input--hasNoCurrency"), !currency)),
      "data-currency": getCurrencyCode,
      "data-currency-symbol": getCurrencySymbol,
      children: _jsx(StyledCurrencyInput, _objectSpread({
        disabled: isDisabled,
        "aria-invalid": isInvalid,
        "aria-label": ariaLabel,
        "aria-describedby": ariaDescribedby,
        "aria-disabled": isDisabled,
        "aria-readonly": isReadOnly,
        ref: ref,
        className: className,
        id: id,
        decimalCharacter: getDecimalPart(),
        decimalCharacterAlternative: '.',
        digitGroupSeparator: getGroupPart(),
        minimumValue: minimumValue.toString(),
        maximumValue: maximumValue.toString(),
        unformatOnHover: false,
        emptyInputBehavior: "zero",
        selectNumberOnly: true,
        modifyValueOnWheel: canModifyValueOnWheel,
        preDefined: preset ? predefinedOptions[getPreset(preset)] : undefined
      }, rest))
    })
  });
});
CurrencyInput.displayName = 'CurrencyInput';
export default CurrencyInput;